/* eslint-disable camelcase */
import React from 'react'
import EmptyDataParagraph from 'components/common/EmptyDataParagraph'
import FetchErrorParagraph from 'components/common/FetchErrorParagraph'
import MaterialTable from 'components/dataTable/MaterialTable'
import { defaultHistoryDTO, HistoryDTO, TableData } from 'models'
import { useCheckData, useLoading } from 'utils/hooks'
import { useGetMongo } from 'utils/hooks/queries'
import useVehicleModal from 'utils/hooks/useVehicleModal'

import { MRT_Row } from 'material-react-table'

const HistoryPage = () => {
  // HISTORY
  const { data: historyData, isLoading, isError } = useGetMongo()
  const { Loading } = useLoading()
  const [vehicleModalActiveId, setVehicleModalActiveId] = React.useState<string>('')
  const { dataAfterCheck, isDataEmpty } = useCheckData<HistoryDTO>(
    historyData as Array<HistoryDTO>,
    defaultHistoryDTO,
  )
  // MODAL
  const { setOpenModal, VehicleModal } = useVehicleModal()

  const handleClick = (row: MRT_Row<TableData>) => {
    setVehicleModalActiveId(row.original.vehicleNo as string)
    setOpenModal(true)
  }

  // RENDER
  if (isLoading) return <Loading />
  if (isError) return <FetchErrorParagraph />
  if (isDataEmpty)
    return <EmptyDataParagraph customSentence="Pas de modifications de réserve à afficher" />

  return (
    <>
      <MaterialTable
        data={dataAfterCheck as TableData[]}
        title="Modifications de réserve"
        onClick={handleClick}
        key="history"
      />
      <VehicleModal
        id={vehicleModalActiveId}
        onClose={() => setVehicleModalActiveId('')}
      />
    </>
  )
}

export default HistoryPage
